import clone from 'clone';

/**
 * mutates the permissions.my property with the data given, as-is
 */
export const getMyPermissions = (state, data) => {
  state.permissions.my = clone(data);
};
